module.exports = __webpack_public_path__ + "img/fnh1.b1bacf30.jpg";